<template>
  <div>
    <v-dialog v-model="emailotp" persistent width="390px">
      <v-card class="overflow-hidden">
        <v-toolbar dense class="gradient-bg elevation-0 white--text">
          <v-toolbar-title>Email Verification and Create</v-toolbar-title
          ><v-spacer />
          <v-icon @click="close_dialog()" class="white--text mr-n3"
            >mdi-close</v-icon
          >
        </v-toolbar>
        <v-card-text class="mt-4">
          <v-form ref="form">
            <label class="ml-7 font-weight-medium">Enter Email OTP</label>
            <v-otp-input
              v-model="emailCode"
              :rules="otp_rules"
              class="mr-6 ml-6 mt-4"
            />
          </v-form>
          <div class="ml-8 mt-4 font-weight-medium">
            Resend OTP in ({{ timer }}s)
            <v-icon
              v-if="!timerRunning"
              color="#EF6C00"
              class="mb-2 ml-2"
              @click="restartTimer"
              >mdi-refresh</v-icon
            >
          </div>

          <!-- @finish="submitcode()" -->
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            small
            class="gradient-bg white--text mb-2 ml-2"
            :loading="createload"
            @click="check_phone"
            >verify</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
  
  <script>
/* eslint-disable */

import { Auth } from "aws-amplify";
export default {
  props: {
    emailotp: Boolean,
    emailitems: Object,
    userDetails: Object,
  },
  data() {
    return {
      otp_rules: [
        (v) => /^\d+$/.test(v) || "OTP must contain only numbers",
        (v) => v.length != 0 || "OTP cannot be empty",
        (v) => v.length == 6 || "Enter Correct OTP",
      ],
      timer: 60,
      timerRunning: false,
      Getorgcurrent: {},
      GetCurrentUserObject2: {},
      OtpUserObject: {},
      emailCode: "",
      createload: false,
    };
  },
  watch: {
    emailotp: {
      handler() {
        // console.log(this.emailitems);
        this.OtpUserObject = this.userDetails;
        // this.userDetails
        this.startTimer();
      },
      immediate: true,
    },
  },
  methods: {
    close_dialog() {
      this.timer = 60;
      this.timerRunning = false;
      this.$emit("clicked", 2);
    },
    check_phone() {
      if (this.$refs.form.validate()) {
        this.login_with_otp();
      } else {
        this.$emit("clicked", 1);
      }
    },
    async login_with_otp() {
      // console.log(this.userDetails,'login');
      this.createload = true;
      try {
        await Auth.sendCustomChallengeAnswer(
          this.OtpUserObject,
          this.emailCode
        );
        await Auth.currentAuthenticatedUser()
          .then((user) => {
            this.$store.commit("SET_AUTH", true);
            this.$store.commit("SET_USEREMAIL", this.emailitems.email);
            this.$store.commit("SET_CURRENT_ROUTE", 0);
            this.createload = false;
            this.$emit("verification", 0);
          })
          .catch((err) => {
            this.createload = false;
            console.log(err);
            // this.$emit("errorMsg", err.errors[0].message);
            this.$emit("errorMsg", "Invalid OTP");
          });
      } catch (error) {
        this.createload = false;
        console.log(error);
        console.log(error.message);

        if (error.message == "Incorrect username or password.") {
          this.$emit("errorMsg", "Invalid OTP");
        } else if (error.message == "Challenge response cannot be empty") {
          this.$emit("errorMsg", "Please Enter OTP Manually");
        } else if (error.message == "Invalid session for the user.") {
          this.$emit(
            "errorMsg",
            "Multiple Attempts, Please Resend OTP and Login again"
          );
        } else {
          this.$emit("errorMsg", error.message);
        }
        // this.$emit("errorMsg", error.message);
      }
    },
    startTimer() {
      this.timerRunning = true;
      this.timer = 60;
      this.countdown();
    },

    restartTimer() {
      this.generate_otp();
      this.timer = 60;
      this.countdown();
      this.timerRunning = true;
    },

    countdown() {
      if (this.timer > 0) {
        setTimeout(() => {
          this.timer--;
          this.countdown();
        }, 1000);
      } else {
        this.timerRunning = false;
      }
    },
    async generate_otp() {
      this.OtpUserObject = {};
      try {
        const user = await Auth.signIn(this.emailitems.email)
          .then((user) => {
            this.OtpUserObject = user;
            // console.log( this.userDetails,'newotp');
            this.$emit("clicked", 3);
            this.focusOnOTPField();
          })
          .catch((err) => {
            this.$emit("errorMsg", err.errors[0].message);
          });
      } catch (error) {
        this.$emit("errorMsg", error.errors[0].message);
      }
    },
  },
};
</script>
  
  <style>
</style>